import { Github, Linkedin, Mail } from "lucide-react";
import { profile } from "../../data/portfolioData";

export const Footer = () => {
    const year = new Date().getFullYear();
    return (
        <footer
            data-testid="site-footer"
            className="relative border-t border-[var(--ink-border)] px-6 py-10 md:px-12 lg:px-16"
        >
            <div className="mx-auto flex max-w-7xl flex-col items-start justify-between gap-6 md:flex-row md:items-center">
                <div>
                    <div className="font-mono text-[11px] uppercase tracking-[0.25em] text-[var(--ink-text-secondary)]">
                        — eof
                    </div>
                    <div className="mt-1 text-sm text-[var(--ink-text-primary)]">
                        Still experimenting.
                    </div>
                </div>

                <div className="flex items-center gap-3">
                    <a
                        href={profile.links.email}
                        data-testid="footer-email-link"
                        aria-label="Email"
                        className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan"
                    >
                        <Mail className="h-4 w-4" />
                    </a>
                    <a
                        href={profile.links.github}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-github-link"
                        aria-label="GitHub"
                        className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan"
                    >
                        <Github className="h-4 w-4" />
                    </a>
                    <a
                        href={profile.links.linkedin}
                        target="_blank"
                        rel="noreferrer"
                        data-testid="footer-linkedin-link"
                        aria-label="LinkedIn"
                        className="inline-flex h-9 w-9 items-center justify-center rounded-md border border-[var(--ink-border)] bg-[var(--ink-surface)] text-[var(--ink-text-secondary)] transition-colors hover:border-ink-cyan/40 hover:text-ink-cyan"
                    >
                        <Linkedin className="h-4 w-4" />
                    </a>
                </div>

                <div className="font-mono text-[11px] text-[var(--ink-text-secondary)]">
                    © {year} {profile.fullName} · built, broken, rebuilt.
                </div>
            </div>
        </footer>
    );
};

export default Footer;
